import { isValidUuId } from '@shared/utils/uuid';
import { PartnerHotelDetailsRouteQueryParams, PartnerHotelIdType } from '../HotelBooking.types';
import { JoyHotelQueryStringParameters } from '@shared/components/DiscountsProvider/hotels/HotelsDiscountsProvider';
import { useQueryParamHelper } from '@shared/core/queryString';
import type { PartialUtmParameters } from '@shared/utils/utmParameters';
import { useUtmParameters } from '@shared/utils/utmParameters';

export const usePartnerHotelQueryParams = (travelPlaceIdArg?: string | null) => {
  const queryParamHelper = useQueryParamHelper();
  const utmParamsFromHook = useUtmParameters();

  // Retrieve query parameters
  const getQueryParam = (param: PartnerHotelDetailsRouteQueryParams | JoyHotelQueryStringParameters) => queryParamHelper.getValueString(param);

  // @todo - Cleanup with ticket - https://withjoy.atlassian.net/browse/TRAV-622
  const travelPlaceId = travelPlaceIdArg || getQueryParam(PartnerHotelDetailsRouteQueryParams.joyPlaceId);

  const skipAvailabilityCheck = queryParamHelper.getValueString('skipAvailabilityCheck') === 'true';
  const idTypeParam = getQueryParam(PartnerHotelDetailsRouteQueryParams.idType) || '';
  const isValidHotelIdType = !!PartnerHotelIdType[idTypeParam as PartnerHotelIdType]; // Validate is valid idtype
  const sourceType = isValidUuId(travelPlaceId) ? PartnerHotelIdType.joy : isValidHotelIdType ? (idTypeParam as PartnerHotelIdType) : PartnerHotelIdType.hotels; // convert value to HotelIdType
  const source = getQueryParam(PartnerHotelDetailsRouteQueryParams.source);

  const queryParamEventId = getQueryParam(PartnerHotelDetailsRouteQueryParams.eventId);
  // `PartialUtmParameters`, not a hand-rolled shape: this is `useUtmParameters()`'s own return type,
  // so a slot added there (e.g. `utm_content`) reaches consumers instead of being typed away.
  const utmParams: PartialUtmParameters = utmParamsFromHook || {};
  const discountCode = getQueryParam(PartnerHotelDetailsRouteQueryParams.discountCode);
  // used for native travel checkout
  const joyHotelDiscountCode = getQueryParam(JoyHotelQueryStringParameters.joyHotelDiscountCode);
  // Share Your Stay codes, read for the native-checkout branch of `PartnerHotelRedirect` alone. Every
  // other exit from that page either goes through `hotelRoutes.buildRelativeUrl` — which retains both
  // codes on its own — or leaves Joy entirely. So this is the one hop that has to carry them by hand,
  // and it is the hop that lands on checkout, the only place either code is ever read.
  const joyReferralCode = getQueryParam(JoyHotelQueryStringParameters.joyReferralCode);
  const joyReferralRewardCode = getQueryParam(JoyHotelQueryStringParameters.joyReferralRewardCode);

  return {
    travelPlaceId,
    sourceType,
    source,
    queryParamEventId,
    utmParams,
    discountCode,
    joyHotelDiscountCode,
    joyReferralCode,
    joyReferralRewardCode,
    skipAvailabilityCheck,
  };
};
